import { Box, Button, Checkbox, TextField, Typography } from "@mui/material";
import moment from "moment";

const UpdateOrderHistory = ({ data, updateData }) => {
  return (
    <Box
      component={"form"}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        padding: "1rem",
      }}
      onSubmit={(e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const json = Object.fromEntries(formData);
        json.isDelivery = json.isDelivery === "on" ? true : false;
        json.amountPayment = Number(json.amountPayment);
        json.discount = Number(json.discount);
        json.probablyDeliveryDate = moment(json.probablyDeliveryDate).format(
          "YYYY-MM-DDTHH:mm:ss.SSS"
        );
        updateData(json);
      }}
    >
      <Typography variant="h6">Buyurtmaga o'zgartirish kiritish</Typography>
      <TextField
        defaultValue={data.description}
        label="Buyurtma haqida izoh"
        name="description"
        size="small"
        multiline
      />
      <TextField
        label="To'lov"
        name="amountPayment"
        size="small"
        defaultValue={data.amountPayment}
      />
      <TextField
        label="Skidka"
        name="discount"
        size="small"
        defaultValue={data.discount}
      />
      <TextField
        label="Yetkazib berish sanasi"
        // name="probablyDeliveryDate"
        size="small"
        type="date"
        defaultValue={moment(data.probablyDeliveryDate).format("YYYY-MM-DD")}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Typography variant="body1">Yetkazib berish</Typography>
        <Checkbox name="isDelivery" defaultChecked={data.delivery} />
      </Box>
      <TextField
        label="Yetkazib berish manzili"
        name="address"
        size="small"
        defaultValue={data.address}
      />
      <Button type="submit" variant="contained" size="small">
        Saqlash
      </Button>
    </Box>
  );
};

export default UpdateOrderHistory;
